import { render, staticRenderFns } from "./LivingSituationEditorTay.vue?vue&type=template&id=c22d5f9c&scoped=true&"
import script from "./LivingSituationEditorTay.vue?vue&type=script&lang=js&"
export * from "./LivingSituationEditorTay.vue?vue&type=script&lang=js&"
import style0 from "./LivingSituationEditorTay.vue?vue&type=style&index=0&id=c22d5f9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22d5f9c",
  null
  
)

export default component.exports